import { useState, useEffect } from 'react';

export const useTokenCheck = () => {
  const [tokenAvailable, setTokenAvailable] = useState(false);

  useEffect(() => {
    // Function to check if token exists
    const checkToken = () => {
      const token = sessionStorage.getItem('Token');
      setTokenAvailable(!!token);
    };

    // Check initially
    checkToken();

    // Create an interval to check periodically
    const intervalId = setInterval(checkToken, 1000);

    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  return tokenAvailable;
};
